import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Container, Stack } from '../components/ui/layout';

const STORAGE_COMPANY = 'orion_company_id';
const STORAGE_USERNAME = 'orion_remember_username';

export default function LoginPage() {
  const [companyId, setCompanyId] = useState(() => localStorage.getItem(STORAGE_COMPANY) || '');
  const [username, setUsername] = useState(() => localStorage.getItem(STORAGE_USERNAME) || '');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (user) {
      const from = location.state?.from?.pathname || '/';
      navigate(from, { replace: true });
    }
  }, [user, location.state?.from?.pathname, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const code = companyId.trim();
    if (!code) {
      setError('Company ID is required');
      return;
    }
    if (!username.trim()) {
      setError('Username is required');
      return;
    }
    if (!password) {
      setError('Password is required');
      return;
    }
    setIsLoading(true);
    try {
      const result = await login(username, password, code);
      if (result.success) {
        setPassword('');
        localStorage.setItem(STORAGE_COMPANY, code);
        localStorage.setItem(STORAGE_USERNAME, username.trim());
        const from = location.state?.from?.pathname || '/';
        navigate(from, { replace: true });
      } else {
        setError(result.message || 'Login failed');
      }
    } catch (err) {
      const msg = err.response?.data?.message || err.message || 'Login failed';
      setError(msg);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container style={{ paddingTop: 'var(--space-5)', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Stack gap="var(--space-4)" style={{ width: '100%', maxWidth: 360 }}>
    <div className="login-page">
      <div className="login-card">
        <div className="login-brand">
          <h1>Orion</h1>
          <p>AI console</p>
        </div>
        <form onSubmit={handleSubmit} className="login-form">
          {error && <div className="login-error" role="alert">{error}</div>}
          <div className="form-group">
            <label htmlFor="company-id">Company ID</label>
            <input
              id="company-id"
              type="text"
              value={companyId}
              onChange={(e) => setCompanyId(e.target.value)}
              placeholder="Company ID"
              autoComplete="organization"
              disabled={isLoading}
            />
          </div>
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Username or email"
              autoComplete="username"
              disabled={isLoading}
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              autoComplete="current-password"
              disabled={isLoading}
            />
          </div>
          <button type="submit" className="login-submit" disabled={isLoading}>
            {isLoading ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
      </Stack>
    </Container>
  );
}
